module.exports = __webpack_public_path__ + "files/6a7883bbe6a845099d24a264c6f9edbb.svg";